"use client";

import { useEffect, useRef } from "react";

export default function LoanLeaseClient({ locale }: { locale: "en" | "zh" }) {
  const openedRef = useRef(false);
  const isZh = locale === "zh";

  useEffect(() => {
    if (!openedRef.current) {
      openedRef.current = true;
      window.open(
        "https://www.enamotorsusa.com/apply-online/",
        "_blank",
        "noopener,noreferrer"
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-black space-y-6">
        <h1 className="text-2xl md:text-3xl font-bold">
          {isZh ? "贷款 / 租赁申请" : "Loan / Lease Application"}
        </h1>
        <p>
          {isZh ? (
            <>
              申请表已在新窗口中打开。如未自动打开，请点击
              <a
                href="https://www.enamotorsusa.com/apply-online/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline mx-1"
              >
                这里
              </a>
              。
            </>
          ) : (
            <>
              Our application form has opened in a new tab. If it did not open
              automatically,
              <a
                href="https://www.enamotorsusa.com/apply-online/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline mx-1"
              >
                open the application form
              </a>
              .
            </>
          )}
        </p>
      </main>
    </div>
  );
}
